import React from "react";
import { createContext, useCallback, useState } from "react";
export const MarketSelectorContext = createContext({
    visible: false,
    onOpen: () => { },
    onClose: () => { },
    onToggle: () => { },
});
export const MarketSelectorConsumer = MarketSelectorContext.Consumer;
const MarketSelectorProvider = (props) => {
    const [visible, setVisible] = useState(false);
    const onOpen = useCallback(() => setVisible(true), []);
    const onClose = useCallback(() => setVisible(false), []);
    const onToggle = useCallback(() => setVisible(!visible), [visible]);
    const MarketSelectorHandlers = {
        visible,
        onOpen,
        onClose,
        onToggle,
    };
    return (React.createElement(MarketSelectorContext.Provider, { ...props, value: MarketSelectorHandlers }));
};
export default MarketSelectorProvider;
